<div class="SingleStepCheckoutSummaryPageTemplate container-v2">
  <sd-heading class="heading"></sd-heading>

  <div class="MainContent">
    <sd-checkout-switch-profile></sd-checkout-switch-profile>
    <sd-receipt-type-tabs></sd-receipt-type-tabs>
    <sd-receipt-address></sd-receipt-address>
    <sd-timeslot-list></sd-timeslot-list>
    <sd-additional-options></sd-additional-options>
    <sd-checkout-payment></sd-checkout-payment>
  </div>

  <div class="BodyContent">
    <sd-checkout-contacts></sd-checkout-contacts>
  </div>

  <div class="SideContent">
    <sd-checkout-order-summary></sd-checkout-order-summary>
  </div>
</div>
